import type { PblCaseListFilter, PblCaseListRow } from './types';
import { isPblDashboardCaseFilter, matchesPblDashboardCaseFilter } from './dashboardFilter';

export const filterPblCaseListRows = <TRow extends PblCaseListRow>(
  rows: TRow[],
  filter: PblCaseListFilter,
  keyword: string
) => {
  const normalizedKeyword = keyword.trim().toLowerCase();

  return rows.filter((item) => {
    const matchesFilter =
      filter === 'all' ||
      item.status === filter ||
      (isPblDashboardCaseFilter(filter) && matchesPblDashboardCaseFilter(item.backendStatus, filter));

    if (!matchesFilter) return false;
    if (!normalizedKeyword) return true;

    return [item.caseId, item.enquiryCategory, item.applicantName, item.legalServiceNeeds, item.creationDate]
      .join(' ')
      .toLowerCase()
      .includes(normalizedKeyword);
  });
};
